import { useState } from "react";
import { useIPMAStationActions } from "./useIPMAStationActions";

type ConfirmActionType = {
  type: "archive" | "restore";
  stationId: string;
  stationName: string;
} | null;

export const useConfirmationDialog = (onSuccess: () => void) => {
  const [isOpen, setIsOpen] = useState(false);
  const [confirmAction, setConfirmAction] = useState<ConfirmActionType>(null);
  const [isLoading, setIsLoading] = useState(false);

  const { handleArchive, handleRestore } = useIPMAStationActions();

  const openDialog = (action: NonNullable<ConfirmActionType>) => {
    setConfirmAction(action);
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
    setConfirmAction(null);
  };

  const handleConfirm = async () => {
    if (!confirmAction) return;

    setIsLoading(true);
    try {
      if (confirmAction.type === "archive") {
        await handleArchive(confirmAction.stationId);
      } else {
        await handleRestore(confirmAction.stationId);
      }
      closeDialog();
      onSuccess();
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isOpen,
    confirmAction,
    isLoading,
    openDialog,
    closeDialog,
    handleConfirm,
  };
}; 